let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ahxSD"), load("dIcOd")]).then(() => parcelRequire('ekO4Z'));